// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PhoneOutlinedSvg from "@fishx/icons-svg/es/asn/PhoneOutlined";
import FishxIcon from '../components/FishxIcon';

var PhoneOutlined = function PhoneOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PhoneOutlinedSvg
  }));
};

PhoneOutlined.displayName = 'PhoneOutlined';
export default React.forwardRef(PhoneOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PhoneOutlined.js
// module id = 3776
// module chunks = 0